module.exports = __webpack_public_path__ + "static/media/62.e7888ba2.png";